var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 98,
    viewBox: "0 0 360 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.55136,
    y: 4.9791,
    width: 349.397,
    height: 87.6355,
    fill: "#1D26FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.55136,
    y: 4.9791,
    width: 349.397,
    height: 87.6355,
    stroke: "white",
    strokeWidth: 3.31953
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176.394,
    y: 1.16183,
    width: 7.21276,
    height: 7.21276,
    fill: "white",
    stroke: "#1790FF",
    strokeWidth: 2.32367
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75803,
    y: 1.16183,
    width: 7.21276,
    height: 7.21276,
    fill: "white",
    stroke: "#1790FF",
    strokeWidth: 2.32367
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16183,
    y: 89.4616,
    width: 7.21276,
    height: 7.21276,
    fill: "white",
    stroke: "#1790FF",
    strokeWidth: 2.32367
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.394,
    y: 89.4616,
    width: 7.21276,
    height: 7.21276,
    fill: "white",
    stroke: "#1790FF",
    strokeWidth: 2.32367
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 351.626,
    y: 89.2383,
    width: 7.21276,
    height: 7.21276,
    fill: "white",
    stroke: "#1790FF",
    strokeWidth: 2.32367
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 351.626,
    y: 1.16183,
    width: 7.21276,
    height: 7.21276,
    fill: "white",
    stroke: "#1790FF",
    strokeWidth: 2.32367
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdown);
export default __webpack_public_path__ + "static/media/countdown.2e9c7ce9883f6d5ec3973a33652b0704.svg";
export { ForwardRef as ReactComponent };